export default __webpack_public_path__ + "fonts/woff/iranyekanwebextrablack.woff";